module.exports = __webpack_public_path__ + "img/2cca467.svg";